// Umbral a partir del cual la lista aplanada de filas visibles se virtualiza
// (solo se montan en el DOM las filas dentro del viewport + overscan).
export const VIRTUALIZE_THRESHOLD = 100;

// Alto de fila fijo usado por el modo virtualizado (debe calzar con el
// min-h + márgenes verticales de MenuItemRow: 38px + 2px + 2px).
export const ROW_HEIGHT = 42;

// Cuántos módulos recientes se conservan (los más nuevos primero).
export const MAX_RECENT_ITEMS = 6;

export const DRAWER_WIDTH_EXPANDED = 296;
export const DRAWER_WIDTH_COMPACT = 68; // riel de solo íconos, siempre visible

// Alto de la barra superior (Nav.js usa h-20 = 80px). El riel persistente
// arranca justo debajo, y Layout.js reserva este mismo ancho como padding
// izquierdo para que el contenido de la página nunca quede tapado.
export const NAV_HEIGHT = 80;
